/* eslint-disable @typescript-eslint/unbound-method */
import { Component, Vue } from 'vue-property-decorator';
import platform from '@/shared/utils/platform';
import { Form } from '@hb/finance-ui/src/form/types';
import UbtHelper from '@/shared/tools/ubtHelper';
import { platformIdentityManager } from '@/shared/identity-verification';
import { AuthSceneTypeEnum } from '@/shared/identity-verification/types';
import { VerifySceneEnum } from '@/shared/verify-credit-controller/types';
import { ubtSendError } from '@/shared/utils/ubt';
import { agreementService } from '@/service/confirm-agreements';
import { isNeedSubmitVerifyPreCheckScene } from '../const';

@Component
export default class VerifyBasicPersonal extends Vue {
  /** ubt埋点api */
  protected ubtHelper = new UbtHelper('臻有钱_个人信息');

  /** 表单是否验证通过 */
  protected isFormReady = false;

  /** 提交按钮 是否 透明底 */
  protected submitBtnInTransparent = false;

  /** 提交按钮 是否 在loading状态 */
  protected submitBtnInLoading = false;

  public get platformValue(): string {
    if (platform.isHelloApp) {
      return 'app';
    } if (platform.isAlipayMini) {
      return 'alimini';
    } if (platform.isDingTalk) {
      return 'DingH5';
    }
    return 'h5';
  }

  /** 开始验证：校验步骤提交前的事项 */
  protected async checkPreVerifySubmitState(verifyScene: VerifySceneEnum): Promise<boolean> {
    try {
      if (isNeedSubmitVerifyPreCheckScene(verifyScene)) {
        /** 身份证实名一致性验证 */
        const checkUserIdentityRes = await platformIdentityManager.checkUserAuth(
          AuthSceneTypeEnum.PRE_LENDING,
        );

        if (!checkUserIdentityRes) {
          return Promise.resolve(false);
        }

        /** 用户同意臻有钱相关协议验证 */
        const confirmAgreementRes = await agreementService.confirmFinanceAgreements();

        if (!confirmAgreementRes) {
          return Promise.resolve(false);
        }
      }
    } catch (err) {
      /** 因上述非核心流程，若前置校验异常，不阻塞后续的流程进行 */
      ubtSendError(err as Error);

      return Promise.resolve(false);
    }

    return Promise.resolve(true);
  }

  protected checkFormReady(): void {
    if (this.$refs.form) {
      this.isFormReady = (this.$refs.form as Form).checkReady();
    }
  }

  mounted(): void {
    this.ubtHelper.enterPage();
    this.$ubtPageButton('臻有钱_个人信息');

    // 置顶滚动条
    window.scrollTo(0, 0);
  }

  beforeDestroy(): void {
    this.ubtHelper.leavePage();
  }
}
